import { Component, HostBinding, Input } from '@angular/core'

@Component({
  selector: 'app-payment-methods',
  imports: [],
  templateUrl: './payment-methods.component.html',
  styleUrl: './payment-methods.component.sass',
})
export class PaymentMethodsComponent {
  @Input() theme: 'content-primary' | 'auto' = 'auto'

  @HostBinding('class') get classes () {
    return `e--theme-${this.theme}`
  }
}
